import { createPortal } from "react-dom";

const Modal = ({ children }) => {
  const node = document.getElementById("Modal");
  return createPortal(children, node);
};

export default Modal;
